export default "__VITE_ASSET__24a2bebf__"